var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Transform, Type } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { HeapGlobalEventProperties } from "./heap.dtos";
import { TefcaProvider } from "./features.dtos";
import { willNeverHappen } from "./utils";
export var AuthTarget;
(function (AuthTarget) {
    AuthTarget["MedAllies"] = "MedAllies";
    AuthTarget["CommonWell"] = "CommonWell";
    AuthTarget["Fallback"] = "Fallback";
})(AuthTarget || (AuthTarget = {}));
export function authTargetFromTefcaProvider(tefcaProvider) {
    switch (tefcaProvider) {
        case TefcaProvider.CommonWell:
            return AuthTarget.CommonWell;
        case TefcaProvider.MedAllies:
            return AuthTarget.MedAllies;
    }
    return willNeverHappen(tefcaProvider);
}
export function tefcaProviderFromAuthTarget(authTarget) {
    switch (authTarget) {
        case AuthTarget.CommonWell:
            return TefcaProvider.CommonWell;
        case AuthTarget.MedAllies:
            return TefcaProvider.MedAllies;
    }
    return willNeverHappen(authTarget);
}
export class ClearVerifyInput {
}
__decorate([
    IsString()
], ClearVerifyInput.prototype, "redirectUrl", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], ClearVerifyInput.prototype, "sandboxMode", void 0);
export class ClearVerifyTokenDto {
}
__decorate([
    IsString()
], ClearVerifyTokenDto.prototype, "sessionId", void 0);
__decorate([
    IsString()
], ClearVerifyTokenDto.prototype, "state", void 0);
__decorate([
    IsString()
], ClearVerifyTokenDto.prototype, "url", void 0);
export class ClearIAL2RedirectURLInput {
}
__decorate([
    IsString()
], ClearIAL2RedirectURLInput.prototype, "redirectUrl", void 0);
__decorate([
    IsEnum(AuthTarget)
], ClearIAL2RedirectURLInput.prototype, "authTarget", void 0);
__decorate([
    IsBoolean()
], ClearIAL2RedirectURLInput.prototype, "sandboxMode", void 0);
__decorate([
    Type(() => HeapGlobalEventProperties),
    ValidateNested(),
    IsOptional()
], ClearIAL2RedirectURLInput.prototype, "heapGlobalEventProperties", void 0);
export class ClearIAL2RedirectURLDto {
}
__decorate([
    IsString()
], ClearIAL2RedirectURLDto.prototype, "state", void 0);
__decorate([
    IsString()
], ClearIAL2RedirectURLDto.prototype, "url", void 0);
export class ClearWebhookInput {
}
__decorate([
    IsString()
], ClearWebhookInput.prototype, "event_id", void 0);
__decorate([
    IsString()
], ClearWebhookInput.prototype, "event_type", void 0);
__decorate([
    IsString()
], ClearWebhookInput.prototype, "object_name", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    Transform(({ value }) => new Date(value * 1000), { toClassOnly: true })
], ClearWebhookInput.prototype, "created_at", void 0);
class ClearIAL2IdTokenAddressDto {
}
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenAddressDto.prototype, "street_address", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenAddressDto.prototype, "locality", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenAddressDto.prototype, "region", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenAddressDto.prototype, "postal_code", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenAddressDto.prototype, "country", void 0);
export class ClearIAL2AccessTokenDto {
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    IsString()
], ClearIAL2AccessTokenDto.prototype, "aud", void 0);
__decorate([
    IsNumber()
], ClearIAL2AccessTokenDto.prototype, "iat", void 0);
__decorate([
    IsString()
], ClearIAL2AccessTokenDto.prototype, "iss", void 0);
__decorate([
    IsString()
], ClearIAL2AccessTokenDto.prototype, "jti", void 0);
__decorate([
    IsString()
], ClearIAL2AccessTokenDto.prototype, "sub", void 0);
__decorate([
    IsString()
], ClearIAL2AccessTokenDto.prototype, "client_id", void 0);
__decorate([
    IsNumber()
], ClearIAL2AccessTokenDto.prototype, "exp", void 0);
export class ClearIAL2IdTokenDto {
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    IsString()
], ClearIAL2IdTokenDto.prototype, "aud", void 0);
__decorate([
    IsNumber()
], ClearIAL2IdTokenDto.prototype, "iat", void 0);
__decorate([
    IsString()
], ClearIAL2IdTokenDto.prototype, "iss", void 0);
__decorate([
    IsString()
], ClearIAL2IdTokenDto.prototype, "jti", void 0);
__decorate([
    IsString()
], ClearIAL2IdTokenDto.prototype, "sub", void 0);
__decorate([
    IsNumber()
], ClearIAL2IdTokenDto.prototype, "exp", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenDto.prototype, "given_name", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenDto.prototype, "family_name", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenDto.prototype, "middle_name", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenDto.prototype, "middle_initial", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenDto.prototype, "gender", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenDto.prototype, "sex", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenDto.prototype, "birthdate", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenDto.prototype, "date_of_birth", void 0);
__decorate([
    Type(() => ClearIAL2IdTokenAddressDto),
    ValidateNested(),
    IsOptional()
], ClearIAL2IdTokenDto.prototype, "address", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenDto.prototype, "phone_number", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2IdTokenDto.prototype, "email", void 0);
export class ClearIAL2TokensDto {
}
__decorate([
    Type(() => ClearIAL2IdTokenDto),
    ValidateNested()
], ClearIAL2TokensDto.prototype, "accessTokenContents", void 0);
__decorate([
    Type(() => ClearIAL2IdTokenDto),
    ValidateNested()
], ClearIAL2TokensDto.prototype, "idTokenContents", void 0);
__decorate([
    IsString()
], ClearIAL2TokensDto.prototype, "idToken", void 0);
__decorate([
    IsString(),
    IsOptional()
], ClearIAL2TokensDto.prototype, "refreshToken", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], ClearIAL2TokensDto.prototype, "expiresIn", void 0);
__decorate([
    IsEnum(AuthTarget)
], ClearIAL2TokensDto.prototype, "authTarget", void 0);
export class ClearIAL2RefreshTokenInput {
}
__decorate([
    IsString()
], ClearIAL2RefreshTokenInput.prototype, "refreshToken", void 0);
